import styled, {css} from 'styled-components';

import {ms} from '../../styles/normalizeSize';
import {View} from '../../uikit/View';

export const OptionsContainer = styled(View)<{fullWidth?: boolean}>`
  position: absolute;
  transform: translateZ(0);

  ${p =>
    p.fullWidth &&
    css`
      padding-left: ${ms(20)};
      padding-right: ${ms(20)};
    `}
`;
